'use client';

import { Card } from '@app/app/_components/Card/Card';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Link } from '@app/app/_components/Link/Link';
import { useHomeNavigation } from '@app/app/_hooks/useHomeNavigation';
import { useTranslations } from 'next-intl';

interface Props {
    error: Error & { digest?: string };
}

export default function TransportError({ error }: Props) {
    const t = useTranslations();

    const { homeLink, handleHomeClick, shouldReload } = useHomeNavigation();

    return (
        <div className="flex min-h-full flex-col items-center justify-start py-6 md:px-8">
            <Card className="items-center gap-8 p-8 md:min-w-dialog">
                <Heading>{t('general.error')}</Heading>

                {shouldReload ? (
                    <button onClick={handleHomeClick} className="text-sm font-medium text-primary-500">
                        {t('general.returnToHome')}
                    </button>
                ) : (
                    <Link href={homeLink}>{t('general.returnToHome')}</Link>
                )}
            </Card>

            {process.env.NODE_ENV === 'development' && (
                <Card className="mt-8 bg-red-200 p-8">
                    <div className="text-red-800 font-bold">Error in esales/transport:</div>
                    <div className="text-red-700 mt-2">{error.message}</div>
                    {error.digest && <div className="text-red-600 mt-1 text-xs">Digest: {error.digest}</div>}
                    <pre className="text-red-700 mt-4 overflow-auto text-xs">{error.stack}</pre>
                </Card>
            )}
        </div>
    );
}
